import { PartnerPerfStore } from './../stores/partner-perf-store';
import { codeSplit, Controller, FetchOptions, Result, AnalyticsStore, FetchPageOptions } from 'bernie-core';
import { PageData } from 'bernie-http';
import { UiStore, UserAuthStore, ProgramStore } from 'stores';

// util
import analyticsUtil from '../util/AnalyticsUtil';
import { pageNames } from '../data/page-names';

import moment from 'moment';
import { flowResult } from 'mobx';

export class PartnerPerfController implements Controller {
  public pageId = pageNames.partnerPerf;
  public path = '/:localeName/analytics';
  public routeName = 'programs';
  public bundles = [];

  public exact = true;

  public component = codeSplit(() => import(/* webpackChunkName: "programs-page" */ '../views/partner-perf-page'));

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    const { stores, request, isServer } = options;

    const analyticsStore: AnalyticsStore = stores && stores.get<AnalyticsStore>('analytics');
    const userAuthStore: UserAuthStore = stores && stores.get<UserAuthStore>('userAuth');
    const partnerPerfStore: PartnerPerfStore = stores && stores.get<PartnerPerfStore>('partnerPerfStore');

    const { partnerId } = userAuthStore.partnerizeAccount;

    const { startDate, endDate } = partnerPerfStore.timePeriod;

    //utc time string format
    const startDateUTCTime = moment(startDate).utc().format();
    const endDateUTCTime = moment(endDate).utc().format();

    const uiStore = stores?.get<UiStore>('uiStore');

    const context = request.context;

    uiStore?.setPageName(this.pageId);

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, context);

    return flowResult(
      partnerPerfStore.fetchPzAnalytics({
        partnerId,
        startDateTime: startDateUTCTime,
        endDateTime: endDateUTCTime,
      }),
    ).then(() => Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Affiliate Hub Analytics' }) as Promise<PageData>;
  }
}
